export enum SORT_ORDER {
	ASC = "-1",
	DESC = "1",
	DEFAULT = "0",
}

export enum ORDER_SORTING_COLUMN {
	ORDER_NO = "orderNumber",
	DATE = "startDate",
	HOURS = "noOfHours",
	CREATED = "metadata.created",
	CITY = "address.city",
}

export enum CONSULTANT_SORTING_COLUMN {
	FIRST_NAME = "firstName",
	LAST_NAME = "lastName",
	EMPLOYEE_NO = "profile.employeeNumber",
	STATUS = "active",
}

export enum CUSTOMER_SORTING_COLUMN {
	CUSTOMER_NAME = "name",
	CUSTOMER_NO = "customerNumber",
	VAT_N0 = "vatNumber",
	CREATED = "metadata.created",
}

export enum CONTRACT_SORTING_COLUMN {
	NAME = "name",
	CREATED = "metadata.created",
	UPDATED = "metadata.updated",
	STATUS = "active",
}

export enum RECRUITMENT_SORTING_COLUMN {
	FIRST_NAME = "firstName",
	LAST_NAME = "lastName",
	CREATED = "metadata.created",
	NEXT_ACTION_DATE = "profile.recruitment.nextActionTime",
	NOTES = "profile.recruitment.notes",
	UPDATED = "metadata.updated",
	AD = "profile.recruitment.adId",
}

export enum INVOICE_SORTING_COLUMN {
	INVOICE_NO = "invoiceNumber",
	INVOICE_DATE = "invoiceDate",
	TOTAL = "total",
	CUSTOMER_NAME = "invoiceName",
}

export enum INVOICE_BATCH_SORTING_COLUMN {
	TO = "date",
	POOL = "pool",
	STATUS = "status",
	CREATED = "metadata.created",
}

export enum TIME_REPORT_SORTING_COLUMN {
	CONSULTANT = "consultant.firstName",
	DIFF_BILLED_TIME = "billedDiff",
	ORDER = "job.orderNumber",
	STATUS = "status",
	DURATION = "shiftDuration",
}
